import { connect } from 'react-redux'
import * as action from '../../state/list/action'
import * as anamnesisAction from '../../state/anamnesis/action'
import AnamnesisList from '../list/AnamnesisList'
import { selectCustomer } from '../../../customer/state/detail/selector'
import * as selector from '../../state/list/selector'
import { isIPRProviderStore } from '../../../globals/state/selector'
import { selectUserStore } from '../../../security/state/auth/selector'

const mapStateToProps = (state, props) => {
    const customer = selectCustomer(state)

    return {
        customerId: customer.id,
        isIprReadOnly: props.isIprReadOnly,
        store: customer.store,
        anamnesisList: selector.selectAnamnesisList(state),
        isUserFromCustomerStore: selectUserStore(state) === customer.store,
        isIPRProviderStore: isIPRProviderStore(state, customer.store),
        showAnamnesis: selector.selectShowAnamnesis(state),
        isInfoLegendShown: selector.selectShowInfoLegendShown(state),
    }
}

const mapDispatchToProps = {
    findOrCreateAnamnesis: anamnesisAction.findOrCreateAnamnesis,
    findByCustomerId: action.findByCustomerId,
    toggleAnamnesis: action.toggleAnamnesis,
    toggleInfoLegend: action.toggleInfoLegend,
    changeAnamnesis: anamnesisAction.changeAnamnesis,
    saveAnamnesis: anamnesisAction.saveAnamnesis,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnamnesisList)



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/task-widget/AnamnesisListWidgetContainer.js